// External deps
import React, { useState, createContext } from 'react';
import PropTypes from 'prop-types';

// Internal deps
import ModalUserTrazability from '../components/Modals/ModalUserTrazability';
import useLoading from '../hooks/useLoading';
import { showError } from '../utils/toastUtils';
import { getFirstDateRequestAdapter } from '../adapters/userRequestsAdapter';

export const UserTrazabilityContext = createContext();
UserTrazabilityContext.displayName = 'UserTrazabilityContext';

const UserTrazabilityProvider = ({children}) => {
 const {setLoading} = useLoading();
 const [showTrazabilityModal, setShowTrazabilityModal] = useState(false);
 const [firstDateRequest, setFirstDateRequest] = useState('');
 
 const handleFirstDateRequest = () => {
    setLoading(true);
    getFirstDateRequestAdapter().then((res) => {
        setLoading(false);
        setFirstDateRequest(res);
      }).catch((err) => {
        showError(err); 
        setLoading(false);
      });
};
 const handleShowTrazabilityModal = (show) => {
    setShowTrazabilityModal(show);
    if (show) handleFirstDateRequest();
  };

 return(
    <UserTrazabilityContext.Provider
    value={{handleShowTrazabilityModal}}>
        <>
        {children}
        {showTrazabilityModal &&  firstDateRequest.length && (
            <ModalUserTrazability
                showTrazabilityModal={showTrazabilityModal}
                setShowTrazabilityModal={setShowTrazabilityModal}
                firstDateRequest={firstDateRequest}
            />
        )}
        </>
    </UserTrazabilityContext.Provider>
 )
};
UserTrazabilityProvider.propTypes = {
    children: PropTypes.node.isRequired
  };
  
  export default UserTrazabilityProvider;